export default {
  radarPartA: [],
  radarPartB: [],
  radarPartC: [],
  showHostsMap: false,
  showWindowsEvents: false,
  showFileMonitoring: false,
  hostsMapData: {},
  elasticGlobalURL: ''
};
